import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ADMIN_BASE_PATH } from './adminConfig';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';
import Dashboard from './Dashboard';
import NewsManagement from './NewsManagement';
import NewsForm from './NewsForm';
import MatchManagement from './MatchManagement';
import MatchForm from './MatchForm';
import StandingsManagement from './StandingsManagement';
import StandingForm from './StandingForm';
import PhotoManagement from './PhotoManagement';
import PhotoForm from './PhotoForm';
import VideoManagement from './VideoManagement';
import VideoForm from './VideoForm';
import PlayerManagement from './PlayerManagement';
import PlayerForm from './PlayerForm';
import CoachingStaffManagement from './CoachingStaffManagement';
import CoachingStaffForm from './CoachingStaffForm';
import TechnicalStaffManagement from './TechnicalStaffManagement';
import TechnicalStaffForm from './TechnicalStaffForm';
import FinancialDocumentManagement from './FinancialDocumentManagement';
import FinancialDocumentForm from './FinancialDocumentForm';
import SocialStaffManagement from './SocialStaffManagement';
import SocialStaffForm from './SocialStaffForm';

const AdminRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-georgian">იტვირთება...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/news" element={<NewsManagement />} />
      <Route path="/news/new" element={<NewsForm />} />
      <Route path="/news/:id" element={<NewsForm />} />
      <Route path="/matches" element={<MatchManagement />} />
      <Route path="/matches/new" element={<MatchForm />} />
      <Route path="/matches/:id/edit" element={<MatchForm />} />
      <Route path="/standings" element={<StandingsManagement />} />
      <Route path="/standings/new" element={<StandingForm />} />
      <Route path="/standings/:id/edit" element={<StandingForm />} />
      <Route path="/photos" element={<PhotoManagement />} />
      <Route path="/photos/new" element={<PhotoForm />} />
      <Route path="/photos/:id/edit" element={<PhotoForm />} />
      <Route path="/videos" element={<VideoManagement />} />
      <Route path="/videos/new" element={<VideoForm />} />
      <Route path="/videos/:id/edit" element={<VideoForm />} />
      <Route path="/players" element={<PlayerManagement />} />
      <Route path="/players/new" element={<PlayerForm />} />
      <Route path="/players/:id/edit" element={<PlayerForm />} />
      <Route path="/coaching-staff" element={<CoachingStaffManagement />} />
      <Route path="/coaching-staff/new" element={<CoachingStaffForm />} />
      <Route path="/coaching-staff/:id/edit" element={<CoachingStaffForm />} />
      <Route path="/technical-staff" element={<TechnicalStaffManagement />} />
      <Route path="/technical-staff/new" element={<TechnicalStaffForm />} />
      <Route path="/technical-staff/:id/edit" element={<TechnicalStaffForm />} />
      <Route path="/financial-documents" element={<FinancialDocumentManagement />} />
      <Route path="/financial-documents/new" element={<FinancialDocumentForm />} />
      <Route path="/financial-documents/:id/edit" element={<FinancialDocumentForm />} />
      <Route path="/social-staff" element={<SocialStaffManagement />} />
      <Route path="/social-staff/new" element={<SocialStaffForm />} />
      <Route path="/social-staff/:id/edit" element={<SocialStaffForm />} />
      <Route path="*" element={<Navigate to={`${ADMIN_BASE_PATH}/dashboard`} replace />} />
    </Routes>
  );
};

export default AdminRoutes;
